<template>
    <CardShell>

        <UnderlinedHeading class="ph3 ph4-ns">People were also interested in...</UnderlinedHeading>
        <ToolList class="" :tools="similarListings" />

    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import UnderlinedHeading from '@/components/controls/UnderlinedHeading.vue';
import ToolList from '@/components/global/ToolList.vue';

export default {
    props: {
        similarListings: {
            type: Array
        }
    },
    components: {
        CardShell,
        UnderlinedHeading,
        ToolList
    }
};
</script>
